<template>
  <div class="history-description-modal">
    <modal-frame :showModalFlag="modalFrameDisplay" v-on:backdropClickEvent="closeModal">
      <div class="modal-header">
        <h1>通話先詳細</h1>
        <img src="/images/close_icon.svg" @click="closeModal" />
      </div>
      <div class="modal-body">
        <div class="portrate-column">
          <user-portrate :target="attendee" :displaySize="'large'"/>
        </div>
        <div class="attendee-description">
          <div class="info name">{{ attendee.name }}</div>
          <div class="info description" v-html="attendeeDescriptionHTML"></div>
          <div class="info type"><span class="title">通話上の立場:</span>{{ attendee.type }}</div>
          <div class="info call-state"><span class="title">通話の状態:</span>{{ attendee.call_state }}</div>
          <div class="info call-time"><span class="title">通話時間:</span>{{ callTimeDisplay }}</div>
        </div>
        <div class="attendee-controll">
          <button class="add-addressbook-btn" :class="{disable: !addressBookAddable}" @click="addAddressBook">連絡先に追加</button>
          <button class="callback-btn" :class="{disable: !callAvailable}" @click="phoneCallBack">通話</button>
        </div>
      </div>
    </modal-frame>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapState, mapGetters, mapActions } from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'
import UserPortrate from '@/components/appView/common/UserPortrate.vue'

export default {
  name: 'HistoryDescriptionModal',

  components: {
    ModalFrame,
    UserPortrate,
  },

  props: {
    callTarget: Object,
    attendee: Object,
    modalFrameDisplay: Boolean
  },

  emits: [
    'phoneCallBackEvent',
    'closeEvent',
    'addAddressBookEvent',
  ],

  data () {
    return {
    }
  },

  computed: {
    ...mapState({
      addressBook: state => state.addressBook.addressCategories,
      availableUsers: state => state.user.users,
    }),

    ...mapGetters({
      storedEntryWithCategory: 'addressBook/storedEntryWithCategory',
      categorySelectable: 'addressBook/categorySelectable',
      notIncludedCategories: 'addressBook/notIncludedCategories',
      allCategoryIncluded: 'addressBook/allCategoryIncluded',
    }),

    storedEntry () {
      return this.storedEntryWithCategory(this.attendee.narrative_phone_id)
    },

    attendeeDescriptionHTML () {
      if (this.attendee.description) {
        return this.attendee.description.replace(/\n/gi, '<br />')
      }
      return ''
    },

    addressBookAddable () {
      // TODO: check all category includes target narrativePhoneID
      if (this.allCategoryIncluded(this.attendee.narrative_phone_id)) {
        return false
      }
      if (this.availableUsers.some((user) => user.narrative_phone_id === this.attendee.narrative_phone_id)) {
        return false
      }
      return true
    },

    callAvailable () {
      if (this.availableUsers.some((user) => user.narrative_phone_id === this.attendee.narrative_phone_id)) {
        return false
      }
      return true
    },

    callTimeDisplay () {
      let timeString = format(this.attendee.call_start, 'yyyy/MM/dd HH:mm:ss') + '〜'
      if (this.attendee.call_end) {
        timeString += format(this.attendee.call_end, 'HH:mm:ss')
      }
      return timeString
    }
  },

  methods: {
    ...mapActions({
      fetchAddressBook: 'addressBook/fetch',
      createEntry: 'addressBook/createEntry',
    }),

    closeModal () {
      this.$emit('closeEvent')
    },

    addAddressBook () {
      if (this.addressBookAddable) {
        this.$emit('addAddressBookEvent')
      }
    },

    phoneCallBack () {
      if (this.callAvailable) {
        this.$emit('phoneCallBackEvent', this.callTarget.account_name, [this.attendee])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.history-description-modal {
  margin: 0;
  .modal-header {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    padding-bottom: 0;
    h1 {
      margin: 0;
      font-size: 22pt;
      font-weight: normal;
    }
    img {
      width: 26px;
    }
  }
  .modal-body {
    padding: 10px;
    .portrate-column {
      text-align: center;
    }
    .attendee-description {
      margin: 10px 0;
      .info {
        padding: 5px 0;
        span.title {
          font-size: 11pt;
          font-weight: bold;
          padding-right: 10px;
        }
      }
      .name {
        font-size: 21pt;
        text-align: center;
      }
      .description {
        font-size: 11pt;
        text-align: center;
      }
    }
    .attendee-controll {
      display: flex;
      justify-content: space-between;
      button {
        padding: 5px 5px 3px;
        border: 1px solid $normal-btn-color;
        border-radius: 5px;
        background: $normal-btn-color;
        color: $normal-btn-text-color;
        font-weight: bold;
        width: 160px;
        &.disable {
          background-color: $disable-btn-color;
          border-color: $disable-btn-color;
        }
      }
    }
  }
}
</style>